import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { WarningOutlineIcon } from 'cat-ecommerce-alloy';
import styles from './Prop65Warning.module.scss';

const Prop65Warning = ({ message }) => {
  const [t] = useTranslation();
  return (
    <p className="exclude-global d-flex">
      <WarningOutlineIcon
        className={cx(styles['warning-button-icon'], 'me-1')}
        height={20}
        width={20}
      />
      <span className="m-0 text-xs">
        <b>{t('INACTIVITY_WARNING_DIALOG_WARNING_ICON')}</b>: {message}
      </span>
    </p>
  );
};

Prop65Warning.propTypes = {
  message: PropTypes.string.isRequired
};

export default Prop65Warning;
